"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var ZoomRoomChairFill = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_ZoomRoomChairFill_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 8.5h8a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2Zm4-6.75a1.428 1.428 0 1 1 0 2.856A1.428 1.428 0 0 1 8 1.75Zm0 3.36c1.429 0 2.5.64 2.5 1.429 0 .394-.37.714-.714.714H6.214c-.345 0-.714-.32-.714-.714 0-.79 1.07-1.429 2.5-1.429Zm6.512 6.22.888 3.549a.5.5 0 1 1-.97.242l-.906-3.621H11.5a1 1 0 0 0-1 1V15a.5.5 0 1 1-1 0v-2.5c0-1.103.897-2 2-2h2.414a.249.249 0 0 0 .243-.189l.858-3.432a.5.5 0 1 1 .97.242l-.858 3.432a1.23 1.23 0 0 1-.615.776ZM6.5 12.5V15a.5.5 0 1 1-1 0v-2.5a1 1 0 0 0-1-1H2.476l-.906 3.62a.5.5 0 1 1-.97-.241l.888-3.55a1.23 1.23 0 0 1-.614-.775L.015 7.12a.5.5 0 1 1 .97-.242l.858 3.433a.249.249 0 0 0 .243.188H4.5c1.103 0 2 .897 2 2Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_ZoomRoomChairFill_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = ZoomRoomChairFill;
exports["default"] = _default;